import React from "react"
import { useState } from "react"
import { Registration } from "@api"
import { ArrowRight } from "@icons"
import { Button, CheckboxForm, Input, InputVAT } from "@molecules"
import { useModalContext } from "../ModalContenxtProvider"
import {
  autoCompleteField,
  dataObject,
  handleInput,
  validateFormData,
  RegistrationFormFields,
} from "@utils"
import { Modal } from "../Modal"

export const ModalRegistration = () => {
  const { setModalType } = useModalContext()
  const [formData, setFormData] = useState(RegistrationFormFields)
  const [hasFormErrors, setHasFormErrors] = useState(false)
  const checkboxObject = formData.find((item) => item.type === "checkbox")

  // Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = dataObject(formData)
    const isFormValid = await validateFormData(data, formData, setFormData)

    if (isFormValid !== true) setHasFormErrors(isFormValid)

    // Call EP
    if (isFormValid === true) {
      const validFormData = {
        ...data,
        company_vat: data.vatnum,
        domain_id: "670a5c9c-1c12-476e-90a0-bbce8bf56d0c",
        available_services: '["GeoStore"]',
        market_segment: "Téradatbank",
        employee_number: "",
      }

      delete validFormData.checkbox
      delete validFormData.passwordAgain

      setHasFormErrors(false)
      Registration(validFormData, setModalType)
    }
  }

  const handleInputVAT = (name, formattedValue) => {
    setFormData((prevData) => {
      const updatedData = prevData.map((field) =>
        field.name === name
          ? {
              ...field,
              value: formattedValue,
            }
          : field
      )
      return updatedData
    })
  }

  return (
    <Modal>
      <form onSubmit={handleSubmit}>
        <div className="modal-content__body">
          <p>Igénye leadásához EnviMAP fiókra van szüksége!</p>

          {hasFormErrors && (
            <div className="modal-content__body-form-errors">
              <ul>
                {hasFormErrors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="modal-content__body-form">
            {formData.map((formField, index) => {
              if (formField.type !== "checkbox") {
                if (formField.name === "vatnum") {
                  return (
                    <InputVAT
                      key={index}
                      label={formField.label}
                      value={formField.value}
                      onChange={(formattedValue) =>
                        handleInputVAT(formField.name, formattedValue)
                      }
                      name={formField.name}
                      required={formField.required}
                      hasError={formField.hasError}
                      onBlur={(e) =>
                        autoCompleteField(e, "completeByVAT", setFormData)
                      }
                    />
                  )
                } else {
                  return (
                    <Input
                      key={index}
                      label={formField.label}
                      type={formField.type}
                      value={formField.value}
                      onChange={(e) => handleInput(e, setFormData)}
                      name={formField.name}
                      required={formField.required}
                      hasError={formField.hasError}
                      onBlur={
                        formField.name === "company"
                          ? (e) =>
                              autoCompleteField(
                                e,
                                "completeByName",
                                setFormData
                              )
                          : undefined
                      }
                    />
                  )
                }
              }
              return null;
            })}
          </div>
          <div className="modal-content__body-form">
            <CheckboxForm
              checked={checkboxObject.value}
              label={
                <>
                  Elfogadom az{" "}
                  <a
                    href="https://map.envimap.hu/tc-resolver?service=Téradatbank"
                    target="blank"
                  >
                    Általános Szerződési Feltételek
                  </a>
                  -ben leírtakat és hozzájárulok adataim kezeléséhez.
                </>
              }
              name={checkboxObject.name}
              onChange={(e) => handleInput(e, setFormData)}
              value={checkboxObject.value}
              required={checkboxObject.required}
              hasError={checkboxObject.hasError}
            />
            <Button
              iconPosition="after"
              icon={<ArrowRight />}
              text="Regisztráció"
              type="submit"
              value="download"
            />
          </div>
        </div>
      </form>
    </Modal>
  )
}
